import http from 'plugins/axios';

export default {
  createCom(data) {
    return http.post({
      url: '/la/admin/community/account/insert',
      data,
      dataType: 'form'
    });
  },
  getList(data) {
    return http.get({
      url: '/la/admin/community/account/select',
      data
    });
  },
  removeList(data) {
    return http.post({
      url: '/la/admin/community/account/update',
      data,
      dataType: 'form'
    });
  }
};
